import React from "react";
import { Box, Skeleton, useTheme } from "@mui/material";

// Mirrors the Sectors page's MASTER–DETAIL geometry so real content lands
// without a layout shift: from lg up, the performance chart column on the
// left (header, tall chart, horizon pill beneath) and the theme rail on the
// right (header, two-up company cards); below lg they stack, with the tab
// row appearing between the chart and the cards — exactly like the page.
const SectorsSkeleton: React.FC = () => {
  const theme = useTheme();
  const skeletonBg = theme.palette.mode === "dark" ? "rgba(255,255,255,0.09)" : "rgba(0,0,0,0.09)";

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", lg: "minmax(0, 11fr) minmax(0, 9fr)" },
        gap: 2,
        alignItems: "start",
      }}
    >
      {/* Chart column: "Sector Performance" header, the chart, the pill */}
      <Box sx={{ minWidth: 0 }}>
        <Skeleton
          variant="rounded"
          animation="wave"
          height={28}
          sx={{ mb: 1.25, maxWidth: 220, borderRadius: 1, bgcolor: skeletonBg }}
        />
        <Skeleton
          variant="rounded"
          animation="wave"
          sx={{ height: 628, borderRadius: 1.5, bgcolor: skeletonBg }}
        />
        {/* The horizon pill sits left-aligned under the chart */}
        <Skeleton
          variant="rounded"
          animation="wave"
          height={32}
          sx={{ mt: 1.5, width: 230, borderRadius: 1, bgcolor: skeletonBg }}
        />
      </Box>

      {/* Theme rail: header, tab row (below lg only), company cards */}
      <Box sx={{ minWidth: 0 }}>
        <Skeleton
          variant="rounded"
          animation="wave"
          height={28}
          sx={{ mb: 1.25, maxWidth: 260, borderRadius: 1, bgcolor: skeletonBg }}
        />
        <Skeleton
          variant="rounded"
          animation="wave"
          height={32}
          sx={{
            mb: 1.5,
            borderRadius: 1,
            bgcolor: skeletonBg,
            display: { xs: "block", lg: "none" },
          }}
        />
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: 1.25,
          }}
        >
          {Array.from({ length: 12 }, (_, index) => (
            <Skeleton
              key={index}
              variant="rounded"
              animation="wave"
              height={78}
              sx={{ borderRadius: 1.5, bgcolor: skeletonBg }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default SectorsSkeleton;
